var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialog-drag", rawName: "v-dialog-drag" }],
      attrs: {
        visible: _vm.innerVisible,
        title:
          "" +
          _vm.$t("CargoMsg.Cargo_Air") +
          _vm.$t("Message.FreightRateDetails"),
        width: "1000px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "air-price-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _vm.innerVisible
        ? [
            _c("div", { staticClass: "price-dialog-header" }, [
              _c("div", { staticClass: "left" }, [
                _c("h2", [
                  _c("span", [_vm._v(_vm._s(_vm.getPortName(_vm.price.pol)))]),
                  _c("span", { staticStyle: { margin: "0 10px" } }, [
                    _vm._v("————")
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.getPortName(_vm.price.pod)))])
                ]),
                _c("h3", [
                  _vm._v(" " + _vm._s(_vm.$t("Price.FreightNumber")) + " "),
                  _c("span", [_vm._v(_vm._s(_vm.price.priceNo))])
                ])
              ]),
              _c("div", { staticClass: "right green" }, [
                _c(
                  "div",
                  { staticStyle: { flex: "1", "margin-right": "10px" } },
                  [
                    _c(
                      "el-row",
                      { attrs: { type: "flex", justify: "end" } },
                      [
                        _c("el-col", { attrs: { span: 5 } }, [_vm._v("+45")]),
                        _c("el-col", { attrs: { span: 5 } }, [_vm._v("+100")]),
                        _c("el-col", { attrs: { span: 5 } }, [_vm._v("+300")]),
                        _c("el-col", { attrs: { span: 5 } }, [_vm._v("+500")]),
                        _c("el-col", { attrs: { span: 5 } }, [_vm._v("+1000")])
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { type: "flex", justify: "end" } },
                      [
                        _c("el-col", { attrs: { span: 5 } }, [
                          _vm._v(
                            _vm._s(_vm.ColumnUtils.airPriceLabel(_vm.price.p45))
                          )
                        ]),
                        _c("el-col", { attrs: { span: 5 } }, [
                          _vm._v(
                            _vm._s(
                              _vm.ColumnUtils.airPriceLabel(_vm.price.p100)
                            )
                          )
                        ]),
                        _c("el-col", { attrs: { span: 5 } }, [
                          _vm._v(
                            _vm._s(
                              _vm.ColumnUtils.airPriceLabel(_vm.price.p300)
                            )
                          )
                        ]),
                        _c("el-col", { attrs: { span: 5 } }, [
                          _vm._v(
                            _vm._s(
                              _vm.ColumnUtils.airPriceLabel(_vm.price.p500)
                            )
                          )
                        ]),
                        _c("el-col", { attrs: { span: 5 } }, [
                          _vm._v(
                            _vm._s(
                              _vm.ColumnUtils.airPriceLabel(_vm.price.p1000)
                            )
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "price-dialog-content" },
              [
                _c(
                  "div",
                  { staticClass: "description" },
                  [
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 1 } }, [
                                _vm._v(_vm._s(_vm.$t("Pricing.Carrier_Air")))
                              ]),
                              _c(
                                "el-col",
                                { staticClass: "blue", attrs: { span: 4 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.ColumnUtils.resolveColumnLabel(
                                        _vm.TYPE_NAMES.basic_data_Company,
                                        "cmpIdx",
                                        _vm.price.carrier,
                                        "shortName"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 2 } }, [
                                _vm._v(_vm._s(_vm.$t("Pricing.BookingAgent")))
                              ]),
                              _c(
                                "el-col",
                                { staticClass: "blue", attrs: { span: 21 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getBookingAgentName(
                                        _vm.price.bookingAgent
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    [
                      _c("div", [
                        _c("div", { staticClass: "info" }, [
                          _c("span", [_vm._v(_vm._s(_vm.$t("Pricing.Days")))]),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v(_vm._s(_vm.price.days))
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("Pricing.DepartureDay")))
                          ]),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v(_vm._s(_vm.isFrequency))
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.$t("Pricing.Via")))]),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v(_vm._s(_vm.getPortName(_vm.price.via)))
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("Pricing.BeginDate")))
                          ]),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$moment(_vm.price.beginDate)
                                  .format("YYYY-MM-DD") +
                                  " - " +
                                  _vm
                                    .$moment(_vm.price.endDate)
                                    .format("YYYY-MM-DD")
                              )
                            )
                          ])
                        ]),
                        _c("div", { staticClass: "info" }, [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("Pricing.Remarks")))
                          ]),
                          _c("textarea", {
                            staticClass: "blue",
                            staticStyle: {
                              width: "90%",
                              border: "none",
                              "overflow-y": "visible",
                              resize: "none"
                            },
                            attrs: { no: "remarks", readonly: "" },
                            domProps: { value: _vm.price.remarks }
                          })
                        ]),
                        _c("div", { staticClass: "info" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("Pricing.priceNature")))
                          ]),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v(
                              _vm._s(
                                _vm.ColumnUtils.showTypeLabelFunc(
                                  _vm.price.priceNature,
                                  _vm.PriceConstant.PRICE_NATURE
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    ]
                  ],
                  2
                ),
                [
                  _c("fright-sur-charge-grid", {
                    attrs: {
                      "config-module": "202506171",
                      "show-approve": false,
                      "show-selection": false,
                      "show-basic-info": false,
                      "show-cost-or-sell": true,
                      "row-data": _vm.frightSurChargeData,
                      "grid-options": _vm.frightSurChargeDataGrid.gridOptions
                    }
                  })
                ]
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }